import React from 'react';
import { Typography, useTheme } from '@mui/material';
import { POItemGroups, PurchaseOrder, PurchaseOrderItem } from '@domain/purchasing';
import TimelineItem from './TimelineItem';

interface TimelineGroupProps {
    group: POItemGroups
    groupIndex: number;
    headerColumnWidth: number;
    onOrderClick: (order: PurchaseOrder) => void;
    onAddShipmentClick: (item: PurchaseOrderItem) => void;
    weeks: Date[];
    weekWidth: number;
}

const TimelineGroup: React.FC<TimelineGroupProps> = ({
    group,
    groupIndex,
    headerColumnWidth,
    weeks,
    weekWidth,
    onOrderClick,
    onAddShipmentClick,
}) => {
    const theme = useTheme();

    if (group.items.length === 0) {
        return null;
    }

    return (
        <div key={`${groupIndex}`}
            style={{
                backgroundColor: "#DDD",
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
            }}
        >
            <div
                style={{
                    backgroundColor: "#DDD",
                    width: headerColumnWidth,
                    position: 'sticky',
                    left: 0,
                    top: 0,
                    bottom: 0,
                    zIndex: 3,
                    height: '100%',
                    borderRight: '1px solid #e0e0e0',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    padding: '0 20px',
                    boxSizing: 'border-box',
                    overflow: 'hidden',
                }}
            >
                <div style={{
                    padding: '10px 0px',
                }}>
                    <Typography variant="caption" whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis" color="text.secondary" maxWidth="100%">
                        {group.name}
                    </Typography>
                </div>
            </div>

            {group.items.map((item, rowIndex) => (
                <TimelineItem
                    key={`${groupIndex}-${rowIndex}`}
                    item={item}
                    groupIndex={groupIndex}
                    rowIndex={rowIndex}
                    headerColumnWidth={headerColumnWidth}
                    weekWidth={weekWidth}
                    onOrderClick={onOrderClick}
                    onAddShipmentClick={onAddShipmentClick}
                />
            ))}
        </div>
    );
};

export default TimelineGroup;
